module.exports = __webpack_public_path__ + "img/banner-bahia-desk.b3d7ba83.png";